import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule, TranslateLangPipe } from '@gs-2.0/shared';

import { PortalSharedModule } from '../../_shared/shared.module';
import { TextInputComponent } from '../../_shared/components/text-input/text-input.component';
import { AddCharityComponent } from './add-charity/add-charity.component';
import { AddCharityFormComponent } from './add-charity/add-charity-form/add-charity-form.component';
import { AddCharitySummaryComponent } from './add-charity/add-charity-summary/add-charity-summary.component';
import { CharityRoutingModule } from './charity-routing.module';

@NgModule({
  declarations: [AddCharityComponent, AddCharityFormComponent, AddCharitySummaryComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CharityRoutingModule,
    PortalSharedModule,
    SharedModule,
    TranslateLangPipe,
    TextInputComponent,
  ],
})
export class CharityModule {}
